import type { LOAN_REQUEST_OFFER_SOURCE } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { OffersTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position?: number;
    requestId: string;
    source: LOAN_REQUEST_OFFER_SOURCE;
};
export const schemaLoanRequestResolver_GetOffersBySource = OffersTableDefinitionZod.nullable();

export type SchemaLoanRequestResolver_GetOffersBySource = z.infer<typeof schemaLoanRequestResolver_GetOffersBySource>;

export type LoanRequestResolver_GetOffersBySource = Resolver<Arguments, SchemaLoanRequestResolver_GetOffersBySource>;
